import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ClaimingStage } from './../../../api/models/claiming.models';
import { BusinessData } from './../../../api/models/api-models';

@Component({
  selector: 'gmb-status-profile',
  templateUrl: './gmb-status-profile.component.html',
  styleUrls: ['./gmb-status-profile.component.scss'],
  standalone: false,
})
export class GmbStatusProfileComponent {
  @Output() openclaimingEvent = new EventEmitter<void>();
  @Output() reactivateEvent = new EventEmitter<void>();

  @Input() gmbStatus: ClaimingStage;
  @Input() businessData: BusinessData;
  gmbStages = ClaimingStage;

  handleButtonClick(): void {
    this.openclaimingEvent.emit();
  }

  viewListing(): void {
    const url = this.businessData.channels[0]?.searchUrl;
    window.open(url);
  }
}
